import React from 'react'
import styled from 'styled-components'
import { Box } from '../../ui/Elements'
import { useTranslation } from 'react-i18next'
import { Delivery1, Delivery2, Delivery3, Delivery4, Delivery5, Delivery6 } from '../../ui/AllImages'
const DeliveryProcess = () => {
    const { t } = useTranslation()
    return (
        <DeliveryWapper className='container'>
            <Box className='deliveryImagesContainer'>
                <Box className='deliveryImg deliveryImg1'>
                    <img src={Delivery1} alt="Delivery" />
                </Box>
                <Box className='deliveryImg deliveryImg2'>
                    <img src={Delivery2} alt="Delivery" />
                </Box>
                <Box className='deliveryImg deliveryImg3'>
                    <img src={Delivery3} alt="Delivery" />
                </Box>
                <Box className='deliveryImg deliveryImg4'>
                    <img src={Delivery4} alt="Delivery" />
                </Box>
                <Box className='deliveryImg deliveryImg5'>
                    <img src={Delivery5} alt="Delivery" />
                </Box>
                <Box className='deliveryImg deliveryImg6'>
                    <img src={Delivery6} alt="Delivery" />
                </Box>
            </Box>
        </DeliveryWapper>
    )
}
const DeliveryWapper = styled.div`
    background-color: var(--white);
    direction: ltr;
    padding-top: 0px;
    padding-bottom: 50px;
    .deliveryImagesContainer{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    @media (max-width: 991px) {
        .deliveryImg1, .deliveryImg2, .deliveryImg3{
            display: none;
        }
    }
    @media (max-width: 767px) {
        padding-bottom: 20px;
        .deliveryImg4, .deliveryImg5{
            display: none;
        }
    }
`
export default DeliveryProcess
